export const APPLICATIONS_QUERY_KEY = 'APPLICATIONS';
export const TABLES_QUERY_KEY = 'ACCESS_TABLES';

export const API_URLS = {
  Applications: process.env.REACT_APP_API_SERVICE_URL,
  Tables: process.env.REACT_APP_API_SERVICE_URL,
};
